'use client'
import { Typography } from 'components/Contentful'
import { Button } from '@achieve/ascend'
function ButtonClient({ button }) {
  return button ? (
    <Button variant="contained" href={button.linkHref}>
      <Typography
        className={''}
        content={button?.linkText?.json?.content?.[0]}
        variant="bodySm"
        fontWeight="bold"
      />
    </Button>
  ) : null
}
export { ButtonClient }
export default ButtonClient
